import { useEffect } from "react";
import { loadFacebook } from "@/services/facebook";
export default function FBScript() {
  useEffect(() => {
    loadFacebook();
  }, []);
  return null;
}
